import { useAppSelector } from 'app/state'
import { useEffect } from 'react'
import { getToken } from '../api/requests'

export default function useAccessToken(options?: { enabled?: boolean }) {
  const enabled = options?.enabled ?? true
  const accessToken = useAppSelector((state) => state.common.accessToken || state.maps.currentMap?.token)
  useEffect(() => {
    if (enabled && !accessToken) {
      getToken().catch((error) => {
        console.error('useAccessToken: failed to retrieve access token', error)
      })
    }
  }, [enabled, accessToken])

  return accessToken
}
